module.exports = __webpack_public_path__ + "static/media/insta4.0d984739.jpg";